const {states} = require ('../../../../../js-handler/library/states') 

export const form   =  [
 
	{	
		name: "name", 
		value:'', 		
		id:'customer_quickform_name',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "phone", 
		value:'', 		
		id:'customer_quickform_phone',
		html:'',
		type:'textfieldValidator',
		required: false, 
	},
	{	
		name: "email", 
		value:'', 		
		id:'customer_quickform_email',
		html:'',
		type:'textfieldValidator',
		required: false, 
	},

	{	
		name: "bill_to_address", 
		value:'', 
		id:'customer_quickform_bill_to_address',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_to_apt", 
		value:'', 
		id:'customer_quickform_bill_to_apt',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "bill_to_city", 
		value:'', 		
		id:'customer_quickform_bill_to_city',
		html:'',
		type:'textfield',
		required: false, 
	}, 
	{   name: "bill_to_state", 
	    value:'', 		
	    id:'customer_quickform_bill_to_state',
	    html:'',
	    type:'multiselect',
	    options : states, 
	    required: false, 
	},
	{	
		name: "bill_to_zip", 
		value:'', 		
		id:'customer_quickform_bill_to_zip',
		html:'',
		type:'textfield',
		required: false, 
	}, 
	{	
		name: "ship_to_address", 
		value:'', 
		id:'customer_quickform_ship_to_address',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "ship_to_apt", 
		value:'', 
		id:'customer_quickform_ship_to_apt',
		html:'',
		type:'textfield',
		required: false,  
	},
	{	
		name: "ship_to_city", 
		value:'', 		
		id:'customer_quickform_ship_to_city',
		html:'',
		type:'textfield',
		required: false, 
	}, 
	{  name: "ship_to_state", 
	   value:'', 		
	   id:'customer_quickform_ship_to_state',
	   html:'',
	   type:'multiselect',
	   options : states, 
	   required: false, 
	},
	{	
		name: "ship_to_zip", 
		value:'', 		
		id:'customer_quickform_ship_to_zip',
		html:'',
		type:'textfield',
		required: false, 
	}, 

]

//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form))